// CJ - Dialog to show help from local assets/help files or remote URLs
//
import {
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Output,
    ViewChild
} from "@angular/core";

import { UserInfo } from "../../model/userinfo.model";

import * as HELP from "../../service/help.service";

import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { FeedbackDataComponent } from "../../feedback-data/feedback-data.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";


export const ERR_NONE = 0;
export const ERR_NO_INTENT = 101;
export const BUTTON_1 = 1;
export const BUTTON_2 = 2;
export const BUTTON_3 = 3;

@Component({
    selector: "app-feedback-dialog",
    templateUrl: "./feedback.dialog.html",
    styleUrls: ["./feedback.dialog.css"],
    standalone: true,
    imports: [
        MatDialogModule,
        CdkDrag,
        CdkDragHandle,
        MatIconModule,
        MatTooltipModule,
        FeedbackDataComponent,
    ],
})
export class FeedbackDialogComponent {
  @Output() helpEvent = new EventEmitter<any>();

  @ViewChild("content", { static: true }) content: ElementRef;

  userInfo: UserInfo = null;

  constructor(
    private dialogRef: MatDialogRef<FeedbackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    if (data) {
      this.userInfo = data.userInfo;
    } // if (data)
    console.log("FeedbackDialog data=", data);
  }

  close() {
    // User canceled or quit operation
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  save() {
    // bundle the intent and data
    this.close();
  }

  scrollTop() {
    if (this.content.nativeElement) {
      this.content.nativeElement.scrollTop = 0;
    }
  }

  scrollBottom() {
    if (this.content.nativeElement) {
      const el = this.content.nativeElement;
      el.scrollTop = Math.max(0, el.scrollHeight - el.offsetHeight);
    }
  }

  helpDialog() {
    this.helpEvent.emit(HELP.USER_FEEDBACK);
  }
}
